<template>
  <div class="entry">
    <!-- <p class="YH-zhuce">{{$t('signup.Register_account')}}</p> -->
    <div v-if="this.$lang.currentLang=='zh_CN'">
      <div style="display: flex;justify-content: space-between;align-items: center;">
        <span class="YH-zhuce" v-for="(item,index) in signupMethod"
        :key="item.name" 
        @click="tabSignup(index)" 
        style="display:inline-block;font-size:24px;"
        >
          <span :class="{active:!(index-signupTab)}" style="opacity:0.5;color:#000;" >{{item.name}}</span>
          
        </span>
      </div>
      <el-form v-if="this.hideSignup==0" :model="signupForm" ref="signupForm" class="signup-form" :rules="signupRules">
        <!-- <el-form-item label=" " prop="country">
          <el-tooltip class="item" effect="dark" popper-class="atooltip" :content="$t('message.country_is_required')" placement="top-end">
          <el-select v-model="signupForm.country" :placeholder="$t('signup.country_pl')" clearable filterable style="width: 100%;">
            <el-option
              v-for="item in countryArr"
              :key="item.id"
              :label="item.value"
              :value="item.chinaValue">
            </el-option>
            <template slot="prefix"><i style="font-size:20px;color: #595959;" class="iconfont icon-gongsi-"></i></template>
          </el-select>
          </el-tooltip>
          <div class="inputlo">
              <div :class="countryError?'input_spans':'sucess'">
                <span>{{countrytip}}</span>
              </div>
          </div>          
        </el-form-item> -->
        <el-form-item label=" " prop="usr">
          <el-tooltip class="item" effect="dark" popper-class="atooltip" :content="$t('signup.usr')" placement="top-end">
          <el-input
            v-model.trim="signupForm.usr"
            clearable
            ref="signupUsr"
            :placeholder="$t('signup.usr_pl')"
            @clear="Bytecheck"
            @keyup.enter.native="this.$refs.signupPhone.focus()"
            @keyup.native="UserByte"
          >
          <template slot="prefix"><i style="font-size:20px;color: #595959;" class="iconfont icon-yonghu"></i></template>
          </el-input>
          </el-tooltip>           
            <div class="inputlo">
              <div :class="isError?'input_spans':'sucess'" v-show="!Byte">
                <span>{{usrtip}}</span>
              </div>
              <div class="input_span" v-show ="Byte">
                <span style="font-size: 12px;font-weight: bold;">{{$t('signup.Byte_1')}}</span>
                <span style="margin-left:2px;font-size:12px;font-weight:bold;color:#f00;">{{Bytes}}</span>
                <span style="font-size: 12px;font-weight: bold;margin-left: 2px;">{{$t('signup.Byte_2')}}</span>
              </div>
              <!-- <span>{{usrtip}}</span> -->
            </div>
        </el-form-item>
        <!-- <el-form-item label=" " prop="email">
          <el-tooltip class="item" effect="dark" popper-class="atooltip" :content="$t('signup.email_form')" placement="top-end">
          <el-input
            v-model.trim="signupForm.email"
            clearable
            @clear="emailcheck"
            :placeholder="$t('signup.email_pl')"
            ref="signupEmail"
            @keyup.enter.native="$refs.signupPhone.focus()"
          >
            <template slot="prefix"><i style="font-size:20px;color: #595959;" class="iconfont icon-youxiang"></i></template>
          </el-input>
          </el-tooltip>
              <div class="inputlo">
              <div :class="emailError?'email_span':'sucess'">
                <span>{{emailtip}}</span>
              </div>
            </div>
        </el-form-item> -->
        <el-form-item label=" " prop="phone">
          <el-tooltip class="item" effect="dark" popper-class="atooltip" :content="$t('signup.phone_form')" placement="top-end">
          <el-input
            v-model.trim="signupForm.phone"
            clearable
            @clear="phonecheck"
            :placeholder="$t('signup.mobile_pl')"
            ref="signupPhone"
            @keyup.enter.native="$refs.signupCode.focus()"
          >
            <template slot="prefix"><i style="font-size:20px;color: #595959;" class="iconfont icon-shouji1"></i></template>
          </el-input>
          </el-tooltip>
          <div class="inputlo">
              <div :class="phoneError?'phone_span':'sucess'">
                <span>{{phonetip}}</span>
              </div>
            </div>
        </el-form-item>
        <el-form-item label=" " prop="code" class="codebox">
          <div class="codeboxitem">
          <el-tooltip class="item" effect="dark" popper-class="atooltip" :content="$t('signup.code')" placement="top-end">
          <el-input 
            v-model.trim="signupForm.code" 
            clearable
            @clear="codecheck"
            :placeholder="$t('signup.code_pl')"
            ref="signupCode"
            maxlength="6"
            @keyup.enter.native="$refs.signupPwd.focus()"
          >
            <template slot="prefix"><i style="font-size:20px;color: #595959;" class="iconfont icon-a-mingchenganquanshuxinganquandunpai"></i></template>
          </el-input>
          </el-tooltip>
          <button
            type="button" 
            class="button button-solid"
            v-if="show"
            @click="getCodeMobile"
            style="height: 45px;line-height: 38px;padding: 0 21px;font-size: 14px;margin-left:10px;"
          >{{$t('basic.Obtain_code')}}</button>
          <button
            type="button" 
            class="button button-solid"
            style="width:115px; height: 45px;line-height: 38px;padding: 0 22px;font-size: 14px;margin-left:10px;"
            v-if="!show"
          >{{count}} s</button>
          </div>
          <div class="inputlo">
            <div :class="codeError?'code_span':'sucess'">
              <span>{{codetip}}</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item label=" " prop="pwd">
          <el-tooltip class="item" effect="dark" popper-class="atooltip" :content="$t('signup.pwd')" placement="top-end">
          <el-input
            v-model.trim="signupForm.pwd"
            clearable
            type="password"
            class="password clear_pwd"
            auto-complete="new-password"
            :placeholder="$t('signup.pwd_pl')"
            ref="signupPwd"
            @clear="pwdcheck"
            @keyup.enter.native="$refs.signupConfPwd.focus()"
            @input.native="Passwordlevel"
            show-password
          >
            <template slot="prefix"><i style="font-size:20px;color: #595959;" class="iconfont icon-mima"></i></template>
          </el-input>
          </el-tooltip>
          <div class="inputlo">
              <div :class="passpwdError?'pwd_span':'sucess'" v-show="!strength">
                <span>{{pwdtip}}</span> 
              </div>
              <div class="input_span" v-show="strength">
                <span style="font-size: 12px;font-weight: bold;">{{$t('signup.qiangdu')}}</span>
                <span class="juxing" ref="Passwordlevel"></span>
                <span style="font-size: 12px;font-weight: bold;margin-left: 5px;">{{degree}}</span>
              </div>
            </div>
        </el-form-item>
        <el-form-item label=" " prop="confPwd">
          <el-tooltip class="item" effect="dark" popper-class="atooltip" :content="$t('signup.confirm_pl')" placement="top-end">
          <el-input
            v-model.trim="signupForm.confPwd"
            clearable
            type="password"
            class="password clear_pwd"
            auto-complete="new-password"
            :placeholder="$t('signup.confirm_Pwdpl')"
            ref="signupConfPwd"
            @keyup.enter.native="$refs.signupPN.focus()"
            show-password
          >
            <template slot="prefix"><i style="font-size:20px;color: #595959;" class="iconfont icon-querenmima"></i></template>
          </el-input>
          </el-tooltip>
          <div class="inputlo">
              <div :class="confpwdError?'confpwd_span':'sucess'">
                <span>{{confpwdtip}}</span>
              </div>
            </div>
        </el-form-item>
        <!-- <el-form-item label=" " prop="pn">
          <el-tooltip class="item" effect="dark" popper-class="atooltip" :content="$t('signup.pn')" placement="top-end">
          <el-input
            v-model.trim="signupForm.pn"
            clearable
            @clear="pncheck"
            :placeholder="$t('signup.PN_pl')"
            ref="signupPN"
            @keyup.enter.native="submitSignupPhone('signupForm')"
          >
            <template slot="prefix"><i style="font-size:20px;color: #595959;" class="iconfont icon-shucaiqi"></i></template>
          </el-input>
          </el-tooltip>
          <div class="inputlo">
              <div :class="pnError?'pn_span':'sucess'">
                <span>{{pntip}}</span>
              </div>
            </div>
          <el-popover
          popper-class="popoverPn"
          placement="right"
          width="220"
          @show="showHandle"
          @hide="hideHandle"
          trigger="click">
          <img style="border: 1px dashed;" src="@/assets/img/pnMessage.png" />
          <i slot="reference" class="iconfont icon-bangzhu pnMessage" :class="statusPN?'pnMessageYes':'pnMessageNo'"></i>
          </el-popover>
        </el-form-item> -->
        <el-form-item class="submit-container">
          <el-button class="login-solid" @click="submitSignupPhone('signupForm')">
            <span class="loginName">{{$t('signup.signup')}}</span>
          </el-button>
        </el-form-item>
      </el-form>
      <el-form v-if="this.hideSignup==1" :model="signupForm" ref="signupForm" class="signup-form" :rules="signupRules">
        <!-- <el-form-item label=" " prop="country">
          <el-tooltip class="item" effect="dark" popper-class="atooltip" :content="$t('message.country_is_required')" placement="top-end">
          <el-select v-model="signupForm.country" :placeholder="$t('signup.country_pl')" clearable filterable style="width: 100%;">
            <el-option
              v-for="item in countryArr"
              :key="item.adCode"
              :label="item.value"
              :value="item.adCode">
            </el-option>
            <template slot="prefix"><i style="font-size:20px;color: #595959;" class="iconfont icon-gongsi-"></i></template>
          </el-select>
          </el-tooltip>
          <div class="inputlo">
              <div :class="countryError?'input_spans':'sucess'">
                <span>{{countrytip}}</span>
              </div>
          </div>           
        </el-form-item> -->
        <el-form-item label=" " prop="usr">
          <el-tooltip class="item" effect="dark" popper-class="atooltip" :content="$t('signup.usr')" placement="top-end">
          <el-input
            v-model.trim="signupForm.usr"
            clearable
            ref="signupUsr"
            :placeholder="$t('signup.usr_pl')"
            @clear="Bytecheck"
            @keyup.enter.native="this.$refs.signupPhone.focus()"
            @keyup.native="UserByte"
          >
          <template slot="prefix"><i style="font-size:20px;color: #595959;" class="iconfont icon-yonghu"></i></template>
          </el-input>
          </el-tooltip>           
            <div class="inputlo">
              <div :class="isError?'input_spans':'sucess'" v-show="!Byte">
                <span>{{usrtip}}</span>
              </div>
              <div class="input_span" v-show ="Byte">
                <span style="font-size: 12px;font-weight: bold;">{{$t('signup.Byte_1')}}</span>
                <span style="margin-left:2px;font-size:12px;font-weight:bold;color:#f00;">{{Bytes}}</span>
                <span style="font-size: 12px;font-weight: bold;margin-left: 2px;">{{$t('signup.Byte_2')}}</span>
              </div>
              <!-- <span>{{usrtip}}</span> -->
            </div>
        </el-form-item>
        <el-form-item label=" " prop="email">
          <el-tooltip class="item" effect="dark" popper-class="atooltip" :content="$t('signup.email_form')" placement="top-end">
          <el-input
            v-model.trim="signupForm.email"
            clearable
            @clear="emailcheck"
            :placeholder="$t('signup.email_pl')"
            ref="signupEmail"
            @keyup.enter.native="$refs.signupCode.focus()"
          >
            <template slot="prefix"><i style="font-size:20px;color: #595959;" class="iconfont icon-youxiang"></i></template>
          </el-input>
          </el-tooltip>
              <div class="inputlo">
              <div :class="emailError?'email_span':'sucess'">
                <span>{{emailtip}}</span>
              </div>
            </div>
        </el-form-item>
        <!-- <el-form-item label=" " prop="phone">
          <el-tooltip class="item" effect="dark" popper-class="atooltip" :content="$t('signup.phone_form')" placement="top-end">
          <el-input
            v-model.trim="signupForm.phone"
            clearable
            @clear="phonecheck"
            :placeholder="$t('signup.mobile_pl')"
            ref="signupPhone"
            @keyup.enter.native="$refs.signupCode.focus()"
          >
            <template slot="prefix"><i style="font-size:20px;color: #595959;" class="iconfont icon-shouji1"></i></template>
          </el-input>
          </el-tooltip>
          <div class="inputlo">
              <div :class="phoneError?'phone_span':'sucess'">
                <span>{{phonetip}}</span>
              </div>
            </div>
        </el-form-item> -->
        <el-form-item label=" " prop="code" class="codebox">
          <div class="codeboxitem">
          <el-tooltip class="item" effect="dark" popper-class="atooltip" :content="$t('signup.code')" placement="top-end">
          <el-input 
            v-model.trim="signupForm.code" 
            clearable
            @clear="codecheck"
            :placeholder="$t('signup.code_pl')"
            ref="signupCode"
            maxlength="6"
            @keyup.enter.native="$refs.signupPwd.focus()"
          >
            <template slot="prefix"><i style="font-size:20px;color: #595959;" class="iconfont icon-a-mingchenganquanshuxinganquandunpai"></i></template>
          </el-input>
          </el-tooltip>
          <button
            type="button" 
            class="button button-solid"
            v-if="show"
            @click="getCodeEmail"
            style="height: 45px;line-height: 38px;padding: 0 21px;font-size: 14px;margin-left:10px;"
          >{{$t('basic.Obtain_code')}}</button>
          <button
            type="button" 
            class="button button-solid"
            style="width:115px; height: 45px;line-height: 38px;padding: 0 22px;font-size: 14px;margin-left:10px;"
            v-if="!show"
          >{{count}} s</button>
          </div>
          <div class="inputlo">
            <div :class="codeError?'code_span':'sucess'">
              <span>{{codetip}}</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item label=" " prop="pwd">
          <el-tooltip class="item" effect="dark" popper-class="atooltip" :content="$t('signup.pwd')" placement="top-end">
          <el-input
            v-model.trim="signupForm.pwd"
            clearable
            type="password"
            class="password clear_pwd"
            auto-complete="new-password"
            :placeholder="$t('signup.pwd_pl')"
            ref="signupPwd"
            @clear="pwdcheck"
            @keyup.enter.native="$refs.signupConfPwd.focus()"
            @input.native="Passwordlevel"
            show-password
          >
            <template slot="prefix"><i style="font-size:20px;color: #595959;" class="iconfont icon-mima"></i></template>
          </el-input>
          </el-tooltip>
          <div class="inputlo">
              <div :class="passpwdError?'pwd_span':'sucess'" v-show="!strength">
                <span>{{pwdtip}}</span> 
              </div>
              <div class="input_span" v-show="strength">
                <span style="font-size: 12px;font-weight: bold;">{{$t('signup.qiangdu')}}</span>
                <span class="juxing" ref="Passwordlevel"></span>
                <span style="font-size: 12px;font-weight: bold;margin-left: 5px;">{{degree}}</span>
              </div>
            </div>
        </el-form-item>
        <el-form-item label=" " prop="confPwd">
          <el-tooltip class="item" effect="dark" popper-class="atooltip" :content="$t('signup.confirm_pl')" placement="top-end">
          <el-input
            v-model.trim="signupForm.confPwd"
            clearable
            type="password"
            class="password clear_pwd"
            auto-complete="new-password"
            :placeholder="$t('signup.confirm_Pwdpl')"
            ref="signupConfPwd"
            @keyup.enter.native="$refs.signupPN.focus()"
            show-password
          >
            <template slot="prefix"><i style="font-size:20px;color: #595959;" class="iconfont icon-querenmima"></i></template>
          </el-input>
          </el-tooltip>
          <div class="inputlo">
              <div :class="confpwdError?'confpwd_span':'sucess'">
                <span>{{confpwdtip}}</span>
              </div>
            </div>
        </el-form-item>
        <!-- <el-form-item label=" " prop="pn">
          <el-tooltip class="item" effect="dark" popper-class="atooltip" :content="$t('signup.pn')" placement="top-end">
          <el-input
            v-model.trim="signupForm.pn"
            clearable
            @clear="pncheck"
            :placeholder="$t('signup.PN_pl')"
            ref="signupPN"
            @keyup.enter.native="submitSignupEmail('signupForm')"
          >
            <template slot="prefix"><i style="font-size:20px;color: #595959;" class="iconfont icon-shucaiqi"></i></template>
          </el-input>
          </el-tooltip>
          <div class="inputlo">
              <div :class="pnError?'pn_span':'sucess'">
                <span>{{pntip}}</span>
              </div>
            </div>
          <el-popover
          popper-class="popoverPn"
          placement="right"
          width="220"
          @show="showHandle"
          @hide="hideHandle"
          trigger="click">
          <img style="border: 1px dashed;" src="@/assets/img/pnMessage.png" />
          <i slot="reference" class="iconfont icon-bangzhu pnMessage" :class="statusPN?'pnMessageYes':'pnMessageNo'"></i>
          </el-popover>
        </el-form-item> -->
        <el-form-item class="submit-container">
          <el-button class="login-solid" @click="submitSignupEmail('signupForm')">
            <span class="loginName">{{$t('signup.signup')}}</span>
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div v-else>
      <div>
        <span class="YH-zhuce"
        style="display:inline-block;font-size:24px"
        >
          <span>{{$t('signup.emailSignup')}}</span>
          
        </span>
      </div>
      <!-- <p class="YH-zhuce">{{$t('signup.emailSignup')}}</p> -->
      <el-form :model="signupForm" ref="signupForm" class="signup-form" :rules="signupRules">
        <!-- <el-form-item label=" " prop="country">
          <el-tooltip class="item" effect="dark" popper-class="atooltip" :content="$t('message.country_is_required')" placement="top-end">
          <el-select v-model="signupForm.country" :placeholder="$t('signup.country_pl')" clearable filterable style="width: 100%;">
            <el-option
              v-for="item in countryArr"
              :key="item.adCode"
              :label="item.value"
              :value="item.adCode">
            </el-option>
            <template slot="prefix"><i style="font-size:20px;color: #595959;" class="iconfont icon-gongsi-"></i></template>
          </el-select>
          </el-tooltip>
          <div class="inputlo">
              <div :class="countryError?'input_spans':'sucess'">
                <span>{{countrytip}}</span>
              </div>
          </div>   
        </el-form-item> -->
        <el-form-item label=" " prop="usr">
          <el-tooltip class="item" effect="dark" popper-class="atooltip" :content="$t('signup.usr')" placement="top-end">
          <el-input
            v-model.trim="signupForm.usr"
            clearable
            ref="signupUsr"
            :placeholder="$t('signup.usr_pl')"
            @clear="Bytecheck"
            @keyup.enter.native="this.$refs.signupPhone.focus()"
            @keyup.native="UserByte"
          >
          <template slot="prefix"><i style="font-size:20px;color: #595959;" class="iconfont icon-yonghu"></i></template>
          </el-input>
          </el-tooltip>           
            <div class="inputlo">
              <div :class="isError?'input_spans':'sucess'" v-show="!Byte">
                <span>{{usrtip}}</span>
              </div>
              <div class="input_span" v-show ="Byte">
                <span style="font-size: 12px;font-weight: bold;">{{$t('signup.Byte_1')}}</span>
                <span style="margin-left:2px;font-size:12px;font-weight:bold;color:#f00;">{{Bytes}}</span>
                <span style="font-size: 12px;font-weight: bold;margin-left: 2px;">{{$t('signup.Byte_2')}}</span>
              </div>
              <!-- <span>{{usrtip}}</span> -->
            </div>
        </el-form-item>
        <el-form-item label=" " prop="email">
          <el-tooltip class="item" effect="dark" popper-class="atooltip" :content="$t('signup.email_form')" placement="top-end">
          <el-input
            v-model.trim="signupForm.email"
            clearable
            @clear="emailcheck"
            :placeholder="$t('signup.email_pl')"
            ref="signupEmail"
            @keyup.enter.native="$refs.signupCode.focus()"
          >
            <template slot="prefix"><i style="font-size:20px;color: #595959;" class="iconfont icon-youxiang"></i></template>
          </el-input>
          </el-tooltip>
              <div class="inputlo">
              <div :class="emailError?'email_span':'sucess'">
                <span>{{emailtip}}</span>
              </div>
            </div>
        </el-form-item>
        <!-- <el-form-item label=" " prop="phone">
          <el-tooltip class="item" effect="dark" popper-class="atooltip" :content="$t('signup.phone_form')" placement="top-end">
          <el-input
            v-model.trim="signupForm.phone"
            clearable
            @clear="phonecheck"
            :placeholder="$t('signup.mobile_pl')"
            ref="signupPhone"
            @keyup.enter.native="$refs.signupCode.focus()"
          >
            <template slot="prefix"><i style="font-size:20px;color: #595959;" class="iconfont icon-shouji1"></i></template>
          </el-input>
          </el-tooltip>
          <div class="inputlo">
              <div :class="phoneError?'phone_span':'sucess'">
                <span>{{phonetip}}</span>
              </div>
            </div>
        </el-form-item> -->
        <el-form-item label=" " prop="code" class="codebox">
          <div class="codeboxitem">
          <el-tooltip class="item" effect="dark" popper-class="atooltip" :content="$t('signup.code')" placement="top-end">
          <el-input 
            v-model.trim="signupForm.code" 
            clearable
            @clear="codecheck"
            :placeholder="$t('signup.code_pl')"
            ref="signupCode"
            maxlength="6"
            @keyup.enter.native="$refs.signupPwd.focus()"
          >
            <template slot="prefix"><i style="font-size:20px;color: #595959;" class="iconfont icon-a-mingchenganquanshuxinganquandunpai"></i></template>
          </el-input>
          </el-tooltip>
          <button
            type="button" 
            class="button button-solid"
            v-if="show"
            @click="getCodeEmail"
            style="height: 45px;line-height: 38px;font-size: 14px;margin-left:10px;"
          >{{$t('basic.Obtain_code')}}</button>
          <button
            type="button" 
            class="button button-solid"
            style="width:115px; height: 45px;line-height: 38px;font-size: 14px;margin-left:10px;"
            v-if="!show"
          >{{count}} s</button>
          </div>
          <div class="inputlo">
            <div :class="codeError?'code_span':'sucess'">
              <span>{{codetip}}</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item label=" " prop="pwd">
          <el-tooltip class="item" effect="dark" popper-class="atooltip" :content="$t('signup.pwd')" placement="top-end">
          <el-input
            v-model.trim="signupForm.pwd"
            clearable
            type="password"
            class="password clear_pwd"
            auto-complete="new-password"
            :placeholder="$t('signup.pwd_pl')"
            ref="signupPwd"
            @clear="pwdcheck"
            @keyup.enter.native="$refs.signupConfPwd.focus()"
            @input.native="Passwordlevel"
            show-password
          >
            <template slot="prefix"><i style="font-size:20px;color: #595959;" class="iconfont icon-mima"></i></template>
          </el-input>
          </el-tooltip>
          <div class="inputlo">
              <div :class="passpwdError?'pwd_span':'sucess'" v-show="!strength">
                <span>{{pwdtip}}</span> 
              </div>
              <div class="input_span" v-show="strength">
                <span style="font-size: 12px;font-weight: bold;">{{$t('signup.qiangdu')}}</span>
                <span class="juxing" ref="Passwordlevel"></span>
                <span style="font-size: 12px;font-weight: bold;margin-left: 5px;">{{degree}}</span>
              </div>
            </div>
        </el-form-item>
        <el-form-item label=" " prop="confPwd">
          <el-tooltip class="item" effect="dark" popper-class="atooltip" :content="$t('signup.confirm_pl')" placement="top-end">
          <el-input
            v-model.trim="signupForm.confPwd"
            clearable
            type="password"
            class="password clear_pwd"
            auto-complete="new-password"
            :placeholder="$t('signup.confirm_Pwdpl')"
            ref="signupConfPwd"
            @keyup.enter.native="$refs.signupPN.focus()"
            show-password
          >
            <template slot="prefix"><i style="font-size:20px;color: #595959;" class="iconfont icon-querenmima"></i></template>
          </el-input>
          </el-tooltip>
          <div class="inputlo">
              <div :class="confpwdError?'confpwd_span':'sucess'">
                <span>{{confpwdtip}}</span>
              </div>
            </div>
        </el-form-item>
        <!-- <el-form-item label=" " prop="pn">
          <el-tooltip class="item" effect="dark" popper-class="atooltip" :content="$t('signup.pn')" placement="top-end">
          <el-input
            v-model.trim="signupForm.pn"
            clearable
            @clear="pncheck"
            :placeholder="$t('signup.PN_pl')"
            ref="signupPN"
            @keyup.enter.native="submitSignupEmail('signupForm')"
          >
            <template slot="prefix"><i style="font-size:20px;color: #595959;" class="iconfont icon-shucaiqi"></i></template>
          </el-input>
          </el-tooltip>
          <div class="inputlo">
              <div :class="pnError?'pn_span':'sucess'">
                <span>{{pntip}}</span>
              </div>
            </div>
          <el-popover
          popper-class="popoverPn"
          placement="right"
          width="220"
          @show="showHandle"
          @hide="hideHandle"
          trigger="click">
          <img style="border: 1px dashed;" src="@/assets/img/pnMessage.png" />
          <i slot="reference" class="iconfont icon-bangzhu pnMessage" :class="statusPN?'pnMessageYes':'pnMessageNo'"></i>
          </el-popover>
        </el-form-item> -->
        <el-form-item class="submit-container">
          <el-button class="login-solid" @click="submitSignupEmail('signupForm')">
            <span class="loginName">{{$t('signup.signup')}}</span>
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="info" style="width: 100%;">
      {{$t('signup.existing_account')}}
      <span
        class="link"
        @click="$emit('changeMode','login')"
      >{{$t('signup.login')}}</span>
    </div>
  </div>
</template>
<script>
// import cookie from "@/assets/js/cookie"
export default {
  data() {
    // var validatecountry = (rule, value, callback) => {
    //     if (!value) {
    //       callback(new Error(''));
    //       this.countrytip = this.$t("message.country_is_required")
    //       this.countryError =true
    //     }else{
    //       this.countrytip = ""
    //       this.countryError =false
    //       callback()
    //     }
    //   };
    var validateusr = (rule, value, callback) => {
      // 邮箱注册：不能输入空格，2-32位，且末位不能是特殊符号（必须是中文/字母/数字/下划线）；手机注册保持原规则
      var ref = this.isEmailSignup() ? /^\S{1,31}[a-zA-Z0-9_一-龥]$/ : /^([a-zA-Z0-9_\u4e00-\u9fa5]{2,32})$/
        if (!value) {
          callback(new Error(''));
          this.usrtip = this.$t("message.uname_is_required")
          this.isError =true
        }else if(!ref.test(value)){
          callback(new Error(''));
          this.usrtip = this.$t('signup.usrformat')
          this.isError =true
        }else{
            callback()
        }
      };
    var validatepwd = (rule, value, callback) => {
        var ref = /^[\w]{6,32}$/
        if (!value) {
          callback(new Error(''));
          this.pwdtip = this.$t("message.pwd_is_required")
          this.passpwdError =true
        }else if(ref.test(value)){
          if(value == 123456||value == 12345678){
            callback(new Error(''));
            this.pwdtip = this.$t('signup.too_simple')
            this.passpwdError =true
          }else{
            callback()
          }
          // callback(new Error(''));
          // this.pwdtip = this.$t('signup.pwdformat')
          // this.passpwdError =true
        }else{
          // callback()
          callback(new Error(''));
          this.pwdtip = this.$t('signup.pwdformat')
          this.passpwdError =true
        }
      };
      var validateemail = (rule, value, callback) => {
        var ref = /^(?=\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$).{0,64}$/
        if (!value) {
          callback(new Error(''));
          this.emailtip = this.$t("message.email_is_required")
          this.emailError =true
        }else if(!ref.test(value)){
          callback(new Error(''));
          this.emailtip = this.$t('message.email_info')
          this.emailError =true
        }else{
          this.emailtip =""
            callback()
        }
      };
      var validatephone = (rule, value, callback) => {
        var ref = /^\d{6,32}$/
        if (!value) {
          callback(new Error(''));
          this.phonetip = this.$t("message.mobile_is_required")
          this.phoneError =true
        }else if(!ref.test(value)){
          callback(new Error(''));
          this.phonetip = this.$t('signup.mobileformat')
          this.phoneError =true
        }else{
          this.phonetip =" "
            callback()
        }
      };
      var validateCode = (rule, value, callback) => {
        var ref = /^[0-9]*$/
        if (!value) {
          callback(new Error(''));
          this.codetip = this.$t("login.YZcode")
          this.codeError =true
        }else if(!ref.test(value)){
          callback(new Error(''));
          this.codetip = this.$t("login.YZcode_format")
          this.codeError =true
        }else{
          this.codetip =" "
            callback()
        }
      };
       var validatepn = (rule, value, callback) => {
         var ref = /^((?=.*[a-zA-Z])[a-zA-Z\d]{14}){1}([a-zA-Z\d]{4})?$/
        if (!value) {
          callback(new Error(''));
          this.pntip = this.$t("message.pn_is_required")
          this.pnError =true
        }else if(!ref.test(value)){
          callback(new Error(''));
          this.pntip = this.$t('signup.pnformat')
          this.pnError =true
        }else{
          this.pntip =""
            callback()
        }
      };
        var validateconfPwd = (rule, value, callback) => {
        if (!value) {
          callback(new Error(''));
          this.confpwdtip = this.$t("message.pwdAgain")
          this.confpwdError =true
        }else if(value !== this.signupForm.pwd){
          callback(new Error(''));
          this.confpwdtip = this.$t("message.pwdNotsame")
          this.confpwdError =true
        }else{
          this.confpwdtip =""
            callback()
        }
      };
    return {
      // countryArr:[],

      //切换注册方式
      signupTab:0,
      hideSignup:0,
      //注册方式
      signupMethod:[
        {
          name:this.$t("signup.phoneSignup"),
          val:0,
        },
        {
          name:this.$t("signup.emailSignup"),
          val:1,
        },
      ],
      codeError:false,
      statusPN:false,
      tooSimple:false,
      confpwdError:false,
      // countryError:false,
      isError:false,
      emailError:false,
      passpwdError:false,
      phoneError:false,
      pnError:false,
      Bytes:'',
      degree:'',
      count:'',
      Byte: false,
      // countrytip:"",
      usrtip:"",
      emailtip:"",
      phonetip:"",
      codetip:"",
      pwdtip:"",
      confpwdtip:"",
      pntip:"",
      strength: false,
      signupForm: {
        // country: "",
        code:"",
        usr: "",
        pwd: "",
        confPwd: "",
        email: "",
        phone: "",
        pn: ""
      },
      //获取验证码
      show: true,
      signupRules: {
        // country:[
        //  {required: true, validator: validatecountry, trigger: 'change' }
        // ],
        // 用户名
        usr: [
          { required: true, validator: validateusr, trigger: 'change' }
        ],
        // 密码
        pwd: [
          { required: true, validator: validatepwd, trigger: 'change' }
        ],

        // pwd: [
        //   {
        //     required: true,
        //     message: this.$t("message.pwd_is_required"),
        //     trigger: "blur"
        //   },
        //   {
        //     pattern: /^[\w]{6,12}$/,//6-32位数字字母下划线
        //     message: this.$t("signup.pwdformat"),
        //     trigger: "blur"
        //   }
        // ],
        // 确认密码
        confPwd: [
          { required: true, validator: validateconfPwd, trigger: 'change' }
        ],
        // confPwd: [
        //   {
        //     validator: (rule, value, callback) => {
        //       if (!value) {
        //         callback(new Error(this.$t("message.pwdAgain")));
        //       } else if (value !== this.signupForm.pwd) {
        //         callback(new Error(this.$t("message.pwdNotsame")));
        //       } else {
        //         callback();
        //       }
        //     },
        //     trigger: "blur",
        //     required: true
        //   }
        // ],
        // 邮箱
         email: [
          { required: true, validator: validateemail, trigger: 'change' }
        ],
        // email: [
        //   {
        //     required: true,
        //     message: this.$t("message.email_is_required"),
        //     trigger: "blur"
        //   },
        //   {
        //     max: 64,
        //     pattern: /^[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)?@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
        //     message: this.$t("message.email_info"),
        //     trigger: "blur"
        //   }
        // ],
        // 手机
        // phone: [
        //   {
        //     required: true,
        //     message: this.$t("message.mobile_is_required"),
        //     trigger: "blur"
        //   },
        //   {
        //     min: 6,
        //     max: 32,
        //     message: this.$t("signup.mobileformat"),
        //     trigger: "blur"
        //   }
        // ],
        phone: [
          { required: true, validator: validatephone, trigger: 'change' }
        ],
        code: [
          { required: true, validator: validateCode, trigger: 'change' }
        ],
        // code: [
        //   { required: true, validator: validatephone, trigger: 'change' }
        // ],
        // pn
        // pn: [
        //   { required: true, validator: validatepn, trigger: 'change' }
        // ],
        // pn: [
        //   {
        //     required: true,
        //     message: this.$t("message.pn_is_required"),
        //     trigger: "blur"
        //   },
        //   {
        //     pattern: /^((?=.*[a-zA-Z])[a-zA-Z\d]{14}){1}([a-zA-Z\d]{4})?$/,
        //     message: this.$t("message.PN_info"),
        //     trigger: "blur"
        //   }
        // ]
      }
    };
    
  },
  // mounted() {
  //   this.getNodeCountry()
  // },
  methods: {
    // 是否为邮箱注册：非中文环境仅邮箱注册；中文环境hideSignup==1为邮箱注册tab
    isEmailSignup() {
      return  this.$lang.currentLang !== 'zh_CN' || this.hideSignup === 1;
    },
    // getNodeCountry(){
    //   var lang
    //   if(this.$lang.currentLang =='zh_CN'){
    //     lang = 'zh_CN'
    //   }else{
    //     lang = 'en_US'
    //   }
    //   this.$request.get("getCountryOfRegistration", {languageCode:lang}).then(res => {
    //       if (res.err == 0) {
    //         this.countryArr = res.dat
    //       }else {
    //         this.countryArr =[]
    //         this.$message.error(this.$t(`errCode.${res.err}`));
    //       }
    //     });
    // },
    // 【获取邮箱验证码】
    getCodeEmail(){
      let check = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
      if (!this.signupForm.email) {
        this.$message.error(this.$t("signup.emailformat"));
      }else if(!check.test(this.signupForm.email)){
        this.$message.error(this.$t("signup.emailformat"));
      }else {
        let param = {
          email: this.signupForm.email,
          msgType: 0,
          channel: 1,
          source: 1,
          i18n:this.$lang.currentLang
        };
        this.$request.get("sendSmsCodeMobile", param).then(res => {
          if (res.err == 0) {
            this.$message.success(this.$t("basic.email_code"));
            const TIME_COUNT = 180;
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.show = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.show = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          }else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
      }
    },
    //切换注册方式
    tabSignup(index){
      // 清除输入内容和提示
      // this.signupForm.country=""
      this.signupForm.code=""
      this.signupForm.phone=""
      this.signupForm.pwd=""
      this.signupForm.confPwd=""
      this.signupForm.email=""
      this.signupForm.usr=""
      // this.countrytip = ''
      this.count=''
      this.show = true;
      this.signupTab = index
      this.usrtip = ''
      this.Byte = false
      this.phonetip = ''
      this.codetip = ''
      clearInterval(this.timer);
      this.timer = null;
      this.show = true
      this.pwdtip = ''
      this.strength = false
      this.confpwdtip = ''
      this.pntip = ''
      this.emailtip = ''
      // 清除边框
      this.$refs.signupForm.resetFields();
      if (index==1) {
        this.hideSignup=index
      }else{
        this.hideSignup=0
      }
    },
    // 【获取手机验证码】
    getCodeMobile() {
      let check = /^1[3456789]\d{9}$/
      if (!this.signupForm.phone) {
        this.$message.error(this.$t("retrieve.mobile_first"));
      }else if(!check.test(this.signupForm.phone)){
        this.$message.error(this.$t("signup.mobileformat1"));
      }else {
        let param = {
          mobile: this.signupForm.phone,
          msgType: 0,
          channel: 0,
          source: 1,
          i18n:this.$lang.currentLang
        };
        this.$request.get("sendSmsCodeMobile", param).then(res => {
          if (res.err == 0) {
            this.$message.success(this.$t("basic.mobile_code"));
            const TIME_COUNT = 90;
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.show = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.show = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          }else if(res.err == 524){
            this.$message.error(this.$t("basic.code_frequently"));
          }else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
      }
    },
    Bytecheck(){
      this.Byte =false
      this.usrtip = this.$t("message.uname_is_required")
    },
    pwdcheck() {
      this.strength =false
      this.pwdtip = this.$t("message.pwd_is_required")
    },
    emailcheck() {

    },
    phonecheck() {

    },
    codecheck() {

    },
    pncheck() {

    },
    UserByte() {
      // 与validateusr保持一致：邮箱注册不能输入空格，2-32位，末位不能是特殊符号
      var usernameRegex = this.isEmailSignup() ? /^\S{1,31}[a-zA-Z0-9_一-龥]$/ : /^([a-zA-Z0-9_\u4e00-\u9fa5]{2,32})$/;
        if (usernameRegex.test(this.signupForm.usr)) {
        //用户格式正确的情况下
        this.Byte = true;
        this.Bytes = this.signupForm.usr.length;
      } else {
        this.Byte = false;
        // this.usrtip = this.$t('signup.usrformat')
      }
    },
    Passwordlevel() {
      var reg = /^[\w]{6,32}$/i; //判断密码格式是否正确
      var reg1 = /[a-zA-Z]/; //字母
      var reg2 = /\d/; //数字
      var reg3 = /_/; //下划线
      if (reg.test(this.signupForm.pwd)) {
        if(this.signupForm.pwd ==123456||this.signupForm.pwd ==12345678){
          this.strength = false;
        }else{
        //密码格式正确的情况下
        if (
          reg1.test(this.signupForm.pwd) &&
          reg2.test(this.signupForm.pwd) &&
          reg3.test(this.signupForm.pwd)
        ) {
          //高级密码
          this.strength = true;
          this.$refs.Passwordlevel.style.backgroundColor = "#3CBD35";
          this.degree = this.$t('signup.qiang')
        } else if (
          (reg1.test(this.signupForm.pwd) &&
          reg2.test(this.signupForm.pwd))||
          (reg1.test(this.signupForm.pwd) &&
          reg3.test(this.signupForm.pwd))||
          (reg2.test(this.signupForm.pwd) &&
          reg3.test(this.signupForm.pwd))
        ) {
          //中级密码
          this.strength = true;
          this.$refs.Passwordlevel.style.backgroundColor = "#FA9D1F";
          this.degree = this.$t('signup.zhong')
        } else if (
          reg1.test(this.signupForm.pwd) ||
          reg2.test(this.signupForm.pwd) ||
          reg3.test(this.signupForm.pwd)
        )
        {
          //低级密码
          this.strength = true;
          this.$refs.Passwordlevel.style.backgroundColor = "#FF0000";
          this.degree = this.$t('signup.di')
        }
        }
      }else {
        this.strength = false;
      }
    },
   showHandle(){
     this.statusPN = true;
   },
      hideHandle(){
     this.statusPN = false;
   },
    // 手机注册
    submitSignupPhone(signupForm) {
      this.$refs[signupForm].validate(valid => {
        if (!valid) return false;
        // if(this.signupForm.country !='中国'){
        //   cookie.setCookie("saveCurrentNode", "web1.shinemonitor.com")
        // }
        this.$request.phoneSignup(this.signupForm).then(res => {
          if (res.err) {
            this.$message.error(this.$t(`errCode.${res.err}`));
          } else {
            this.$message.success(this.$t("signup.success"));
            this.$emit("signupSuc", {
              usr: this.signupForm.usr,
              pwd: this.signupForm.pwd
            });
          }
        });
      });
    },
    // 邮箱注册
    submitSignupEmail(signupForm) {
      this.$refs[signupForm].validate(valid => {
        if (!valid) return false;
        // if(this.signupForm.country !='中国'){
        //   cookie.setCookie("saveCurrentNode", "web1.shinemonitor.com")
        // }
        this.$request.emailSignup(this.signupForm).then(res => {
          if (res.err) {
            this.$message.error(this.$t(`errCode.${res.err}`));
          } else {
            this.$message.success(this.$t("signup.success"));
            this.$emit("signupSuc", {
              usr: this.signupForm.usr,
              pwd: this.signupForm.pwd
            });
          }
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.entry {
  position: relative;
  box-shadow:0px 6px 54px rgba(0,23,4, 0.6);
  display: flex;
  background: #ffffff;
  flex-direction: column;
  border-radius: 10px;
  width: 526px;
  // height:630px;
  height:580px;
  padding: 0px 80px 0px 80px;
  /deep/ .el-form-item__label {
    position: absolute;
    left: -16px;
    padding: 0 8px 0 0;
  }
  /deep/ .el-form-item {
    // height: 4.81vh;
    height: 45px;
    position: relative;
    display: flex;
    align-items: center;
  }
  /deep/ .el-form-item__content {
    flex: 1;
    height: 45px;
    // height: 4.81vh;
  }
 /deep/ .el-input__prefix {
    // width: 2.11vw;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .YH-zhuce {
    height: 28px;
    font-size: 24px;
    text-align: center;
    color: #262626;
    margin: 50px 0 35px 0;
    // margin: 5.13vh 0 3.85vh 0;
    // font-family: Microsoft YaHei;
    // font-weight: bold;
    color: #262626;
    cursor: pointer;
    .active{
      // display: inline-block;
      // border-radius: 5px;
      // padding: 5px;
      opacity: 0.9 !important;
      cursor: auto;
    }
  }
  .signup-form {
    flex: 1;
    .button-solid {
      width: 100%;
      font-size: 20px;
    }
    .codebox{
      // /deep/.el-form-item__content {
      //   display: flex;
      //   align-items: center;
      // }
      .codeboxitem{
        display: flex;
        justify-content: space-between;
      }
      /deep/.el-input {
        width: 240px;
      }
      /deep/.el-input .el-input__inner {
        width: 240px;
      }
      // display: flex;
      // justify-content: space-between;
    }
  }
  .info {
    font-size: 16px;
    color: #595959;
    // line-height: 40px;
    text-align: center;
    position: absolute;
    // bottom: 20px;
    // bottom: 2.57vh;
    // top: 585px;
    top: 525px;
    left: 50%;
    transform: translateX(-50%);
    .link {
      padding: 0 5px;
      color: #1890ff;
        &:hover,&:focus {
        text-decoration: underline;
        color: #1890ff;
      }
        &:active {
      color: #096dd9
      }
    }
  }
  .pnMessage{
    font-size:20px;
    color: #595959;
    position: absolute;
    right: -30px;
    top: 12.5px;
    cursor: pointer;
    }
    .pnMessageYes {
    color: #1890ff;
    }
    .pnMessageNo {
    color: #595959;
    }
  .juxing {
    display: inline-block;
    width: 100px;
    height: 10px;
    border: 0px solid #fff;
    margin-left: 5px;
  }
   .inputlo{
   margin-bottom: -16px;
  //  height: 20px;
 }
 .input_spans, .pwd_span, .email_span,.phone_span,.code_span,.pn_span,.confpwd_span,.tooSimple{
    color: #F56C6C;
    font-size: 12px;
 }
 .sucess {
   font-size: 12px;
   color: #999;
  //  font-family: "Microsoft YaHei";
 }
 /deep/ .el-form-item__error {
   display: none;
 }
}
</style>
<style lang="less">
.atooltip.el-tooltip__popper[x-placement^="top"]{
  margin-bottom: -10px
}
.el-popover.popoverPn {
  box-shadow:0px 6px 18px rgba(0,39,102, 0.6);
  padding: 4px 20px;
}
</style>
